import { Container, Spinner } from "reactstrap"

import React from "react"

export default (props) => (
  <Container className="d-flex justify-content-center">
    <Spinner style={props.small ? {} : { width: "5em", height: "5em" }} />
  </Container>
)
